// Etiquetas legibles del enum TipoTramite (expedientes).
// Fuente única para traducir el `tipo` del expediente (guiones bajos) a un
// título humano. Antes este mapa estaba duplicado e incompleto en 5 páginas.

export const TIPO_TRAMITE_LABELS: Record<string, string> = {
  RECONOCIMIENTO: 'Reconocimiento',
  REEMPADRONAMIENTO: 'Reempadronamiento',
  CAMBIO_AUTORIDADES: 'Cambio de Autoridades',
  CAMBIO_DENOMINACION: 'Cambio de Denominación',
  FUSION: 'Fusión',
  CONFEDERACION: 'Confederación',
  SUBSANACION: 'Subsanación',
  CADUCIDAD: 'Caducidad',
  EXTINCION: 'Extinción',
  RENDICION_ANUAL: 'Rendición Anual',
  RENDICION_CAMPANA: 'Rendición Campaña',
  CONSTITUCION_ALIANZA: 'Constitución de Alianza',
  MODIFICACION_ALIANZA: 'Modificación de Alianza',
  CANDIDATURA: 'Candidatura',
  REGISTRO_AFILIADOS: 'Registro de afiliados',
};

// Devuelve la etiqueta legible o, si no se conoce el tipo, el valor crudo.
export function tipoTramiteLabel(tipo?: string | null): string {
  if (!tipo) return '';
  return TIPO_TRAMITE_LABELS[tipo] || tipo;
}
